var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymenttag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.29102V1.79102H2V12.291H14V10.791H8C7.80109 10.791 7.61032 10.712 7.46967 10.5713C7.32902 10.4307 7.25 10.2399 7.25 10.041V4.04102C7.25 3.8421 7.32902 3.65134 7.46967 3.51069C7.61032 3.37003 7.80109 3.29102 8 3.29102H14ZM1.25 0.291016H14.75C14.9489 0.291016 15.1397 0.370033 15.2803 0.510685C15.421 0.651338 15.5 0.842103 15.5 1.04102V13.041C15.5 13.2399 15.421 13.4307 15.2803 13.5713C15.1397 13.712 14.9489 13.791 14.75 13.791H1.25C1.05109 13.791 0.860322 13.712 0.71967 13.5713C0.579018 13.4307 0.5 13.2399 0.5 13.041V1.04102C0.5 0.842103 0.579018 0.651338 0.71967 0.510685C0.860322 0.370033 1.05109 0.291016 1.25 0.291016V0.291016ZM8.75 4.79102V9.29101H14V4.79102H8.75ZM10.25 6.29102H12.5V7.79102H10.25V6.29102Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymenttag);
export default __webpack_public_path__ + "static/media/paymenttag.30e571835e4e91b843fc28f63466bec3.svg";
export { ForwardRef as ReactComponent };